import { useCallback, useRef } from "react";
import { axiosInstance } from "../api/axios";
import { useDispatch } from "react-redux";
import { setUser } from "../slice/authSlice";
import { setToken, clearToken } from "../auth/tokenStore";

const useRefreshToken = () => {
  const dispatch = useDispatch();
  const refreshPromiseRef = useRef(null);

  const refresh = useCallback(async (deviceIdParam) => {
    const deviceId = deviceIdParam || localStorage.getItem("device_id");

    if (!deviceId) {
      console.error("Device ID가 설정되지 않았습니다.");
      return Promise.reject(new Error("Device ID not found"));
    }

    if (refreshPromiseRef.current) return refreshPromiseRef.current;

    refreshPromiseRef.current = new Promise(async (resolve, reject) => {
      try {
        const response = await axiosInstance.post(
          "/auth/refresh",
          { device_id: deviceId },
          { withCredentials: true }
        );
        setToken(response.data.accessToken);
        dispatch(setUser(response.data.user));
        resolve(response.data.accessToken);
      } catch (error) {
        clearToken();
        reject(error);
      } finally {
        refreshPromiseRef.current = null;
      }
    });

    return refreshPromiseRef.current;
  }, [dispatch]);

  return refresh;
};

export default useRefreshToken;
